import { themeAutomator } from './themeAutomator'
import type {
  AutomatedColorsScheme,
  AutomatedComponentsTheme,
  AutomatedThemeStyles,
} from './themeAutomator/types'
import type { ComponentsTheme } from './types'

export const getInternalTheme = (colorsScheme: AutomatedColorsScheme): AutomatedComponentsTheme => {
  return themeAutomator(colorsScheme, true)
}

export const getAutomatedStyleProp = (prop: keyof AutomatedThemeStyles, defaultValue?: string) => {
  return ({ theme }: { theme: ComponentsTheme }) => {
    if (!theme.automated) {
      return defaultValue
    }

    return theme.automated?.styles?.[prop] || defaultValue
  }
}
